export default "__VITE_ASSET__DjAgwkLV__"